export default __webpack_public_path__ + "static/media/icon-insights-performance-google-revenue.829f251f.svg";